import { Component } from '@angular/core';
import { ApiService } from './services/api/api.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'LionsgateSphere-fe';
    isMobile: boolean = false

    constructor(
        public apiService: ApiService,
        private breakpointObserver: BreakpointObserver,
    ) {
        // this.apiService.getApiData1()

        // this.apiService.loadXML('assets/json/MOVSP.xml')
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });
    }
}
